var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindenLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 338.4",
    style: {
      enableBackground: "new 0 0 960 338.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.1718,
    y1: 112.6182,
    x2: 218.3931,
    y2: 271.8394,
    gradientTransform: "matrix(1 0 0 -1 0 337.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#4A4A4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5698,
    style: {
      stopColor: "#4A4A4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8423,
    style: {
      stopColor: "#4A4A4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A4A4A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M138.8,30c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0l0,0C80.3,30.4,33.3,77.5,33.3,135.5 c0,24,7.9,46.5,22.7,65.4l67.1,84.3l15.7,19.7v-25.2V273v-37.9c0-4.9,3.9-8.8,8.8-8.8h26.1c4.9,0,8.8-3.9,8.8-8.8v-29.2 c0-4.9-3.9-8.8-8.8-8.8h-34.9l0,0c-24.9,0-45.2-20.3-45.2-45.2c0-24.8,20.1-45,44.9-45.2c22,0.2,40.4,15.5,44.2,36.5l0,0 c0.8,5.5,3.7,8.6,8,8.6h43.7c5.2,0,9.3-3.7,8.8-9C237.9,70.6,193.2,30.3,138.8,30L138.8,30z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.7,159.3c14,0,25.3-11.3,25.3-25.3s-11.3-25.3-25.3-25.3S113.3,120,113.3,134S124.7,159.3,138.7,159.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.6,119.2c-5.6-3.7-12.1-5.7-18.2-5.7c-7.3,0-14,2.4-18.7,6.7c-5.3,4.9-8.1,12.1-8.1,20.8v3.8h-11.9 c-0.5,0-0.8,0.4-0.8,0.8v14.8c0,0.5,0.4,0.8,0.8,0.8h11.9v51.7c0,0.5,0.4,0.8,0.8,0.8h16.9c0.5,0,0.8-0.4,0.8-0.8v-51.7h19.3 c0.5,0,0.8-0.4,0.8-0.8v-14.8c0-0.5-0.4-0.8-0.8-0.8H321V141c0-7.2,3.4-11.4,9.4-11.4c3.2,0,6.3,1.1,10,3.5 c0.2,0.1,0.4,0.2,0.7,0.1c0.2-0.1,0.4-0.2,0.5-0.4l6.2-12.6C348,119.9,347.9,119.4,347.6,119.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.1,143.6h-16.9c-0.5,0-0.8,0.4-0.8,0.8V213c0,0.5,0.4,0.8,0.8,0.8h16.9c0.5,0,0.8-0.4,0.8-0.8v-68.6 C376.9,144,376.5,143.6,376.1,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,115.3h-16.9c-0.5,0-0.8,0.4-0.8,0.8v35.3c-4.8-5.7-14.5-9.2-21.6-9.2c-22,0-35.6,14-35.6,36.6 c0,21.9,14.5,36.6,36,36.6c6.6,0,15.4-1.7,21.5-9.6l0.9,7.3c0,0.4,0.4,0.7,0.8,0.7h15.8c0.5,0,0.8-0.4,0.8-0.8v-96.9 C556,115.7,555.7,115.3,555.2,115.3z M536.4,178.8c0,12.7-9.6,19.3-19,19.3c-10.8,0-18.6-8.1-18.6-19.3 c0-11.3,7.6-19.2,18.6-19.2C528.2,159.7,536.4,167.9,536.4,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.5,142.8c-8.1,0-14.9,2.9-21.8,9.4l-0.9-7.7c0-0.4-0.4-0.7-0.8-0.7h-15.1c-0.5,0-0.8,0.4-0.8,0.8v68.5 c0,0.5,0.4,0.8,0.8,0.8h16.8c0.5,0,0.8-0.4,0.8-0.8v-34.9c0-10.4,7.2-18.3,16.7-18.3c9.7,0,15.7,6.7,15.7,17.5v35.8 c0,0.5,0.4,0.8,0.8,0.8h16.9c0.5,0,0.8-0.4,0.8-0.8v-35.9C466.3,153.4,451.4,142.8,436.5,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.6,114.7c-5.4,0-10.8,3.7-10.8,10.7s5.4,10.7,10.8,10.7s10.8-3.7,10.8-10.7 C378.4,118.4,373,114.7,367.6,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M852.2,143.8h-6.8c-0.5,0-0.8,0.4-0.8,0.8v12c-5.8-8.6-15.7-13.7-27.2-13.7c-20.3,0-35.6,15.4-35.6,35.9 c0,20.6,15.3,36.2,35.6,36.2c11.2,0,20.7-4.9,27.2-13.8v11.9c0,0.5,0.4,0.8,0.8,0.8h6.8c0.5,0,0.8-0.4,0.8-0.8v-68.5 C853,144.1,852.7,143.8,852.2,143.8z M845.2,178.9c0,13.4-8.7,27.8-27.8,27.8c-15.8,0-27.2-11.7-27.2-27.9 c0-16.1,11.4-27.7,27.2-27.7C836.5,151.1,845.2,165.5,845.2,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M916.6,210.2l-2.4-5.5c-0.1-0.2-0.3-0.4-0.5-0.4c-0.2-0.1-0.4-0.1-0.6,0c-3.7,1.8-7.2,2.7-10.2,2.7 c-9.8,0-11.8-5.7-11.8-15v-40.9h22.5c0.5,0,0.8-0.4,0.8-0.8v-5.7c0-0.5-0.4-0.8-0.8-0.8h-22.5V124c0-0.2-0.1-0.5-0.3-0.6 c-0.2-0.2-0.4-0.2-0.6-0.2l-6.7,0.7c-0.4,0-0.7,0.4-0.7,0.8v19.2h-13.7c-0.5,0-0.8,0.4-0.8,0.8v5.7c0,0.5,0.4,0.8,0.8,0.8h13.7 V192c0,15.6,6.4,22.9,20.1,22.9c4,0,8.3-1.2,13.2-3.5C916.6,211.1,916.8,210.6,916.6,210.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M698.9,142.8c-8.1,0-14.9,2.9-21.8,9.4l-0.9-7.7c0-0.4-0.4-0.7-0.8-0.7h-15.1c-0.5,0-0.8,0.4-0.8,0.8v68.5 c0,0.5,0.4,0.8,0.8,0.8H677c0.5,0,0.8-0.4,0.8-0.8v-34.9c0-10.4,7.2-18.3,16.7-18.3c9.7,0,15.7,6.7,15.7,17.5v35.8 c0,0.5,0.4,0.8,0.8,0.8h16.9c0.5,0,0.8-0.4,0.8-0.8v-35.9C728.7,153.4,713.7,142.8,698.9,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756.1,193.6c-5.4,0-10.8,3.7-10.8,10.7c0,3.3,1.2,6.1,3.4,8c2,1.7,4.6,2.7,7.4,2.7 c5.4,0,10.8-3.7,10.8-10.7S761.5,193.6,756.1,193.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M635.8,152.1c-6.2-6.8-15.5-10.3-27-10.3c-22.2,0-37.1,14.7-37.1,36.6c0,23,14.7,37.3,38.4,37.3 c11.8,0,23.2-4.3,30-11.3c0.3-0.3,0.3-0.8,0-1.1l-10.8-10.7c-0.2-0.2-0.3-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2 c-3.8,4-12,6.1-17.7,6.1c-10.6,0-17.9-4.9-19.4-12.9h52.4c0.4,0,0.8-0.3,0.8-0.7C645.5,171,642.6,159.6,635.8,152.1z  M591.1,171.2c2.7-8.4,9.3-12.8,18.3-12.8c9.4,0,15.9,4.7,17,12.8H591.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindenLogoDark);
export default __webpack_public_path__ + "static/media/finden-logo-dark.f2e87bcd.svg";
export { ForwardRef as ReactComponent };